<template>
    <button :type="type" class="
                w-full
                grid
                justify-items-center
                items-center
                font-semibold
                bg-primary
                text-white
                border-2 rounded-full
                hover:bg-[#031023]
                transition-all
                p-2
                sm:mt-2
            "
        :class="enabled ? 'border-primary' : 'bg-gray-300 border-gray-300 text-gray-500 pointer-events-none'"
        >
        <div :class="enabled ? 'hover:-translate-x-1 transition-all' : ''">
            <slot />
        </div>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'submit',
        },
        enabled: {
            type: Boolean,
            default: true
        }
    }
}
</script>
